module.exports = __webpack_public_path__ + "static/logo_Bon_Aroma-49e607e9c886a3d0e16e3b68140e7e6e.png";